import { Navigate, Outlet } from "react-router-dom";
import ProtectedLayout from "./ProtectedLayout"
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import Header from "./Header";
import BottomNav from "./Footer";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useCookies } from "react-cookie";
import { useSelector } from "react-redux";
import { useState } from "react";

const WHATSAPP_CONTACTS = [
  { name: "رعنا", label: "خدمات", phone: "09006167070" },
  { name: "رزا", label: "فروش", phone: "09194712712" },
  { name: "پریناز", label: "آموزش", phone: "09006168080" },
];

const WhatsAppFloat = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-20 md:bottom-6 right-4 md:right-6 z-40">
      {/* Dropdown */}
      {open && (
        <div className="mb-4 w-64 rounded-2xl border border-green-100 bg-white p-4 shadow-xl shadow-green-100/50 rtl">
          <div className="flex items-center gap-2 mb-3">
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-green-500 text-white">
              <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
              </svg>
            </div>
            <div>
              <p className="text-sm font-bold text-slate-800">تماس با ما</p>
              <p className="text-[10px] text-slate-400">پشتیبانی واتساپ</p>
            </div>
          </div>
          <div className="space-y-2">
            {WHATSAPP_CONTACTS.map((c, i) => (
              <a
                key={i}
                href={`https://wa.me/${c.phone}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 rounded-xl bg-green-50 px-3 py-2.5 text-sm transition-colors hover:bg-green-100"
              >
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-green-500 text-white text-[10px] font-bold">
                  {c.name[0]}
                </span>
                <div className="min-w-0">
                  <p className="text-xs font-bold text-slate-800">{c.name}</p>
                  <p className="text-[10px] text-slate-400">{c.label}</p>
                </div>
                <span className="mr-auto font-mono text-xs text-green-700">{c.phone}</span>
              </a>
            ))}
          </div>
        </div>
      )}
      {/* Button */}
      <button
        onClick={() => setOpen(!open)}
        className="relative flex h-14 w-14 md:h-16 md:w-16 items-center justify-center rounded-full bg-gradient-to-br from-green-400 to-green-600 shadow-xl shadow-green-200 transition-all hover:scale-110 hover:shadow-2xl focus:outline-none focus:ring-4 focus:ring-green-200 overflow-hidden"
        aria-label="تماس واتساپ"
      >
        <img src="/whatsapp-float.png" alt="WhatsApp" className="h-full w-full object-contain" />
      </button>
    </div>
  );
};

const Layout = () => {
    
    const profile = useSelector((state) => state.auth.profile);

    // اگر ادمین بود → بفرست به پنل ادمین
    if (profile?.role === "admin") {
        return <Navigate to="/admin" replace />;
    }

    const menu = [
        {
            title: "رزروهای من",
            path: "/",
            icon: "/assets/images/icons/events.svg",
        },
        {
            title: "رزرو وقت مژه",
            path: "/reserve",
            icon: "/assets/images/icons/add.svg",
        },
        {
            title: "پروفایل کاربری",
            path: "/profile",
            icon: "/assets/images/icons/user-2.svg",
        },
        {
            title: "پشتیبانی",
            path: "/support",
            icon: "/assets/images/icons/support.svg",
            showOnlyComputer: true,
        },
    ];

    return (
        <ProtectedLayout>

            <div className="flex min-h-screen bg-slate-100">

                {/* Sidebar desktop */}
                <aside className="hidden md:flex flex-col w-64 bg-white shadow-lg p-5">

                    <div className="sticky top-4">

                        <Logo />

                        <nav className="flex flex-col gap-4 mt-10">
                            {menu.map((item) => (
                                <SidebarItem key={item.path} item={item}/>
                            ))}
                        </nav>
                    
                    </div>

                </aside>


                {/* Main section */}
                <div className="flex-1 flex flex-col">

                    <Header />

                    <main className="flex-1 p-4 md:p-8 pb-20 md:pb-8">
                        <div className="bg-white rounded-2xl shadow-custom-md p-4 py-6 md:py-8 md:p-6 min-h-[400px]">
                            <Outlet />
                        </div>
                    </main>

                    {/* دکمه شناور واتساپ */}
                    <WhatsAppFloat />

                </div>


                {/* Mobile Bottom Nav */}
                <BottomNav menu={menu} />

                <ToastContainer
                    position="bottom-center"
                    autoClose={3000}
                    rtl
                />

            </div>

        </ProtectedLayout>
    );
};

export default Layout;